import React, { createContext, useContext, useState, ReactNode, useEffect } from "react";

type Theme = "light" | "dark";

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [theme, setTheme] = useState<Theme>("light");

  useEffect(() => {
    const root = document.documentElement;
    if (theme === "dark") {
      root.style.setProperty("--color-bg", "#1a1818");
      root.style.setProperty("--color-text", "#ece7e1");
      root.style.setProperty("--color-bg-inv", "#ece7e1");
      root.style.setProperty("--color-text-inv", "#1a1818");
    } else {
      root.style.setProperty("--color-bg", "#ece7e1");
      root.style.setProperty("--color-text", "#1a1818");
      root.style.setProperty("--color-bg-inv", "#1a1818");
      root.style.setProperty("--color-text-inv", "#ece7e1");
    }
  }, [theme]);

  const toggleTheme = () => setTheme((prev) => (prev === "light" ? "dark" : "light"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = (): ThemeContextType => {
  const context = useContext(ThemeContext);
  if (!context) throw new Error("useTheme must be used within a ThemeProvider");
  return context;
};

export default ThemeProvider;
